import React from "react";
import InternalPrepaidCreditTools from "../../Internal/PrepaidCreditTools/PrepaidCreditTools"

class VenuePrepaidCreditTools extends React.Component {
  render() {
    return (<div className="PrepaidCreditTools">
        <InternalPrepaidCreditTools
        {...this.props}
        match={this.props.computedMatch} // required because Venue uses ProtectedRoute and Internal uses Route
        dataSource={"venue_admin"}
        headers={{
          code: "Code",
          initialBalance: "Starting Balance",
          currentBalance: "Current Balance",
          status: "Status",
          createdAt: "Created"
        }}
        />
        </div>);
}

}

export default VenuePrepaidCreditTools
